"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useConfirmer", {
    enumerable: true,
    get: function() {
        return useConfirmer;
    }
});
const _react = require("react");
const _ConfirmerContext = require("../contexts/ConfirmerContext");
const useConfirmer = ()=>{
    return (0, _react.useContext)(_ConfirmerContext.ConfirmerContext);
};

//# sourceMappingURL=useConfirmer.js.map